import(/* webpackMode: "eager" */ "/opt/build/repo/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/opt/build/repo/app/providers/posthog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/build/repo/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/build/repo/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpdateNotification"] */ "/opt/build/repo/components/update-notification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/build/repo/lib/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "/opt/build/repo/lib/config-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/opt/build/repo/lib/i18n/language-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisitCounterProvider"] */ "/opt/build/repo/lib/visit-counter-provider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
